import { useEffect, useState } from "react";
import { rpc } from "@/lib/supabase";
import { PageHeader, Loader } from "@/components/kit";
import { AdminTable } from "@/components/AdminTable";
import { formatCOP } from "@/lib/format";

export default function AdminSettlements() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    rpc("admin_get_settlements").then((d) => setRows(d || [])).catch(() => setRows([]));
  }, []);
  if (rows === null) return <Loader />;
  const columns = [
    { key: "driver_name", label: "Conductor", render: (r) => <span className="font-semibold text-white">{r.driver_name || "—"}</span> },
    { key: "delivered_count", label: "Entregas" },
    { key: "total_gmv", label: "Facturado", render: (r) => formatCOP(r.total_gmv) },
    { key: "total_earning", label: "A pagar (75%)", render: (r) => <span className="font-semibold text-emerald-400">{formatCOP(r.total_earning)}</span> },
    { key: "total_commission", label: "Comisión (25%)", render: (r) => <span className="text-[#FF6A00]">{formatCOP(r.total_commission)}</span> },
  ];
  return (
    <div>
      <PageHeader title="Liquidaciones" subtitle="Resumen de pagos por conductor. Los pagos se registran, no se procesan en la plataforma." testId="admin-settlements" />
      <AdminTable columns={columns} rows={rows} testId="admin-settlements-table" empty="Sin liquidaciones" />
    </div>
  );
}
